import React from 'react';
export const WhyItMattersSection = () => {
  return <section className="py-6 md:py-8 bg-bttf-bg text-bttf-text relative overflow-hidden" data-id="element-397">
      <div className="absolute inset-0 bg-bttf-highlight/20 mix-blend-overlay" data-id="element-398"></div>
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-bttf-highlight/30 rounded-full blur-3xl" data-id="element-399"></div>
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-bttf-primary/20 rounded-full blur-3xl" data-id="element-400"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-401">
        <div className="text-center mb-6" data-id="element-402">
          <div className="flex justify-center mb-2" data-id="element-403">
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-404" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-2" data-id="element-405">
            Why This Book Matters Now
          </h2>
          <div className="w-20 h-1 bg-bttf-primary mx-auto" data-id="element-406"></div>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-407">
          <p className="text-xl text-center mb-4 text-bttf-text" data-id="element-408">
            In a world obsessed with the future, Back to the Future reminds us
            of something timeless:
          </p>
          <p className="text-2xl font-bold text-center mb-6 bg-gradient-main text-transparent bg-clip-text font-future tracking-wide" data-id="element-409">
            Our best days aren't behind us—they're waiting for us to believe
            again.
          </p>
          <p className="text-lg text-center text-bttf-subtext mb-8" data-id="element-410">
            This collector's edition isn't just about nostalgia. It's about
            rediscovering wonder, courage, and joy—the fuel that still powers
            every dream worth chasing.
          </p>
          <div className="mt-8 max-w-2xl mx-auto" data-id="element-411">
            <div className="relative" data-id="element-412">
              <div className="absolute -inset-1 bg-gradient-main rounded-lg blur-md opacity-50" data-id="element-413"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t7mqqkM5X5ZNX27GRq945h/Generated_Image_October_24%2C_2025_-_9_55AM.png" alt="Back In Time Book Launch Event" className="relative w-full h-auto rounded-lg shadow-2xl object-cover" data-id="element-414" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const StarIcon = ({
  className
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-415">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-416"></polygon>
  </svg>;